/* eslint-disable react-hooks/exhaustive-deps */
import { useGetFromURLQuery } from "@/api/AppApi/services/builder";
import {
  IField,
  IKeyValue,
} from "@/api/AppApi/services/builder/interfaces/interfaces";
import { useEffect, useRef, useState, useMemo } from "react";
import { Controller, FieldValues, UseFormReturn } from "react-hook-form";
import { Dropdown, DropdownItem, Row } from "@/utils/bootstrap";
import CustomDropdownTitle from "./CustomDropdownTitle";
import InputErrorMsg from "../../form-builder-helpers/InputErrorMsg";
import SearchDropdownTitle from "./SearchDropdownTitle";
import RequiredStar from "@/app/components/lib/RequiredStar";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props extends IField {
  isPC?: boolean;
  form: UseFormReturn<FieldValues, any>;
  isSearch?: boolean;
  isGetKeyValue?: boolean;
  customOnChange?: (value: any) => void;
}
const CustomDropdown: React.FC<Props> = ({
  isPC = false,
  form,
  isSearch = false,
  isGetKeyValue,
  customOnChange,
  ...field
}) => {
  const t = useTranslation();
  const [blured, setBlured] = useState(false);
  const fConfig = field.configurations;

  const formValue = form.watch(fConfig.key);
  const selectedKey = useMemo(() => {
    if (isGetKeyValue) {
      return formValue?.key ?? "-1";
    }

    return formValue ?? "-1";
  }, [formValue, isGetKeyValue]);

  const parentKey = fConfig.parent_key
    ? isGetKeyValue
      ? form.watch(fConfig.parent_key)?.key ?? "-1"
      : form.watch(fConfig.parent_key) ?? "-1"
    : null;
  const getOptions = useGetFromURLQuery({
    url: fConfig.options_url ?? "",
    parentName: fConfig.parent_key?.split("(")?.pop() ?? "",
    parentKey: parentKey,
  });

  const { options, title, disabled } = useMemo(() => {
    let opts: IKeyValue[] = [];
    let isDisabled: boolean;

    if (field.data && field.data.length > 0) {
      opts = field?.data;
      isDisabled = false;
    } else {
      opts = getOptions?.data?.result ?? [];
      isDisabled = parentKey === "-1";
    }

    const calculatedTitle =
      selectedKey === "-1" || !selectedKey || selectedKey === undefined
        ? `${fConfig.placeholder ?? fConfig?.title}`
        : opts.find((option) => option.key == selectedKey)?.value ??
          `${fConfig.placeholder ?? fConfig?.title}`;

    return {
      options: opts,
      title: calculatedTitle,
      disabled: isDisabled,
    };
  }, [
    field.data,
    getOptions?.data?.result,
    selectedKey,
    parentKey,
    fConfig.placeholder,
    fConfig.title,
  ]);

  const currentFormValue = form.getValues(fConfig.key);
  const valueToUse = useMemo(() => {
    console.log({ currentFormValue, fieldValue: field.value });
    if (isGetKeyValue) {
      return currentFormValue && currentFormValue?.key !== "-1"
        ? currentFormValue?.key
        : field.value ?? "-1";
    }
    return currentFormValue && currentFormValue !== "-1"
      ? currentFormValue
      : field.value ?? "-1";
  }, [currentFormValue, field.value]);

  const initValue = useMemo(() => {
    console.log({ valueToUse });
    return valueToUse && valueToUse !== "-1"
      ? options.find((op) => op.key == valueToUse) || { key: "-1", value: "" }
      : { key: "-1", value: "" };
  }, [valueToUse, options]);

  const [searchTerm, setSearchTerm] = useState(initValue?.value || "");

  useEffect(() => {
    console.log({ initValue });
    if (initValue?.value !== searchTerm) {
      setSearchTerm(initValue?.value || "");
    }
  }, [initValue?.value]);

  useEffect(() => {
    if (options?.length === 1) {
      setTimeout(() =>
        form.setValue(
          fConfig.key,
          isGetKeyValue ? options[0] : options[0]?.key,
        
        ),
      );
    }
  }, [options, getOptions.isLoading]);

  useEffect(() => {
    if (!isSearch) return;
    setSearchTerm(initValue?.value || "");
  }, [field.value]);

  useEffect(() => {
    if (!parentKey || !getOptions?.isFetched) return;

    const valueExists = getOptions?.data?.result?.some(
      (op) => op.key == selectedKey,
    );

    if (parentKey === "-1" || (!valueExists && options?.length > 0)) {
      form.setValue(
        fConfig.key,
        isGetKeyValue ? { key: "-1", value: "" } : "-1",
      
      );
    }
  }, [parentKey, getOptions?.isFetched]);

  useEffect(() => {
    if (isSearch && searchTerm === "") {
      form.setValue(
        fConfig.key,
        isGetKeyValue ? { key: "-1", value: "" } : "-1",
      
      );
    }
  }, [searchTerm, isSearch]);

  useEffect(() => {
    if (!isSearch || !fConfig.parent_key) return;

    if (initValue?.key && initValue.key !== "-1") {
      form.setValue(
        fConfig.key,
        isGetKeyValue
          ? { key: initValue.key, value: initValue.value || "" }
          : initValue.key,
      
      );
      setSearchTerm(initValue?.value || "");
    }
  }, [form.watch(fConfig.parent_key ?? ""), isSearch, fConfig.parent_key]);

  const isSelectedRef = useRef(false);
  const optionsToRender =
    isSearch && blured
      ? (options ?? [])?.filter((op) =>
          op.value.toLowerCase().includes((searchTerm || "").toLowerCase()),
        )
      : options ?? [];

  return (
    <div
      className={`${isSearch && "with-search-dropdown"} sort-dropdown w-100 ${
        isPC ? "pc" : ""
      }`}
    >
      {!fConfig.hideLabel && (
        <RequiredStar title={fConfig.title} isRequired={fConfig.is_required} />
      )}
      <Controller
        control={form.control}
        name={fConfig.key}
        rules={{
          validate: (value) =>
            fConfig.is_required && (value === "-1" || !value)
              ? t.this_field_is_required
              : true,
          required: true,
        }}
        render={({ field }) => {
          return (
            <Dropdown
              onToggle={() => {
                if (isSelectedRef.current) {
                  isSelectedRef.current = false;
                  return;
                }
                if (searchTerm !== "") {
                  const selectedOption = options?.find(
                    (op) => op.value === searchTerm,
                  );
                  if (!selectedOption) {
                    setTimeout(() =>
                      form.setValue(
                        fConfig.key,
                        isGetKeyValue
                          ? initValue?.key
                            ? {
                                key: initValue.key,
                                value: initValue.value || "",
                              }
                            : { key: "-1", value: "" }
                          : initValue?.key ?? "-1",
                      
                      ),
                    );
                    setSearchTerm(initValue?.value || "");
                  } else {
                    setSearchTerm(selectedOption?.value || "");
                    setTimeout(() =>
                      form.setValue(
                        fConfig.key,
                        isGetKeyValue ? selectedOption : selectedOption?.key,
                      
                      ),
                    );
                  }
                }
                setBlured(false);
              }}
            >
              <Dropdown.Toggle disabled={disabled} variant="outline" {...field}>
                {isSearch ? (
                  <SearchDropdownTitle
                    placeholder={title}
                    searchTerm={searchTerm || ""}
                    setSearchTerm={(val) => {
                      setBlured(true);
                      setSearchTerm(val || "");
                    }}
                  />
                ) : (
                  <CustomDropdownTitle title={title} disabled={disabled} />
                )}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {optionsToRender.map((option, index) => (
                  <DropdownItem
                    active={option?.key === selectedKey}
                    key={option.value + option.key + index}
                    onClick={() => {
                      isSelectedRef.current = true;
                      setSearchTerm(option.value || "");
                      field.onChange(isGetKeyValue ? option : option.key);
                      if (!!customOnChange)
                        customOnChange(isGetKeyValue ? option : option.key);
                    }}
                  >
                    <Row className="m-0">{option?.value}</Row>
                  </DropdownItem>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          );
        }}
      />
      {fConfig.hint && <div className="field-hint">{fConfig.hint}</div>}
      <InputErrorMsg
        errorMsg={form.formState.errors[fConfig.key]?.message as string}
      />
    </div>
  );
};

export default CustomDropdown;
